export { Environment } from './config';
export type { LibraryConfig } from './config';
export * from './hooks/space/space_helpers';
export { useUsedSpace } from './hooks/space/usedSpace';
export type { VirtualFileSystemProp } from './models/files';
export * from './services';
export { getEncryptedMasterKey } from './services/encryption/encryption.service';
export { FilesService } from './services/files/FilesService';
export { FileUploadService } from './services/files/FileUploadService';
export { FolderCreateService } from './services/files/FolderCreateService';
export { InboxService } from './services/inbox/InboxService';
export {
  getFilePath,
  getFolderPathFromPath,
} from './services/request/RequestHelpers';
export { RequestService } from './services/request/RequestService';
export { ApiError } from './services/API';
export {
  DataType,
  getAllData,
  LOGIN_ERROR,
} from './services/session/session.service';
export {
  ShareService,
  type Inbox,
  type ShareEntryResponse,
  type ShareItem,
  type Shares,
} from './services/share/ShareService';
export type { ShareResponse } from './services/share/ShareService';
export {
  OperationCompiler,
  TransactionBlock,
  TransactionManager,
} from './services/transactions';
export type {
  OperationSpec,
  OperationType,
} from './services/transactions/models/OperationContext';
export type { OperationStatus } from './services/transactions/models/RunnableOperation';
export * from './services/versioning/versioning.service';
export {
  getBasis,
  getCypherCode,
  getInbox,
  getSession,
  getShares,
  getStateVirtualFileSystem,
  getUserData,
  isAuthenticated,
  libraryState,
  setCypherCode,
} from './state';
export { LocalStorage } from './store/LocalStorage';
export * from './types';
import { LibraryConfig, setConfig } from './config';

export const initializeLibrary = (config: LibraryConfig) => {
  console.log('🚀 ~ initializeLibrary ~ config:', config);
  setConfig(config);
};

export type { ConfigurationResponse, Versioning } from './models/configuration';
export { ConfigurationService } from './services/configuration';
export { DownloadService } from './services/download/download.service';
